import { Badge } from "@/components/ui/badge";
import type { StavZakazky } from "@/api/schemas";

const STAV_LABELS: Record<StavZakazky, string> = {
  ponuka: "Ponuka",
  v_priprave: "V príprave",
  vo_vyrobe: "Vo výrobe",
  dokoncena: "Dokončené",
};

/**
 * Kedy sa stav mení (`services/vo_vyrobe.py` na serveri, KOLO 204, 239):
 * prvé tri samy, Dokončenú človek, Kalkulácia presunie do Archívu.
 */
export const STAV_POPIS =
  "Výpočet = ponuka, zákazka AA/Z alebo výrobná varianta = v príprave, " +
  "odoslané na pílu = vo výrobe (samo); dokončenú označíš ručne, " +
  "kalkulácia ju presunie do Archívu";

/** Farebný badge stavu zákazky podľa DESIGN_SYSTEM.md. */
export function StavBadge({ stav }: { stav: StavZakazky }): JSX.Element {
  return <Badge variant={stav}>{STAV_LABELS[stav]}</Badge>;
}

export { STAV_LABELS };
